import { render, staticRenderFns } from "./file-type.vue?vue&type=template&id=41309cb6&scoped=true&lang=pug&"
import script from "./file-type.vue?vue&type=script&lang=ts&"
export * from "./file-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41309cb6",
  null
  
)

export default component.exports